// extracted by mini-css-extract-plugin
module.exports = {"container":"InvitationLinkExpired_container__2WFdN","subTitleRow":"InvitationLinkExpired_subTitleRow__1NhC6"};